Ctrl.$inject = ['$scope', '$state', '$stateParams', '$location'];

function Ctrl($scope, $state, $stateParams, $location){
  	var search = $location.search();
    $scope.type = '';
    if ($location.$$search.type) {
        $scope.type = $location.$$search.type;
    }
}
module.exports = Ctrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/404/controllers/error404.js
 ** module id = 253
 ** module chunks = 1
 **/